import * as Long from "long";
import { selectBuildingUpgradeInfo } from "../../../../selectors/selectExistingBuildingInfo";
import { selectNotEnoughResourcesMissingResources } from "../../../../selectors/selectNotEnoughResources";
export var checkBuildingUpgradeHasEnoughResourceStandard = function (path) { return function (action, state$) {
    var state = state$.value;
    if (!action.premium) {
        var upgradeInfo = selectBuildingUpgradeInfo(action.building);
        var standardCost = upgradeInfo.nextStage.standard.cost;
        var standardCostItem = standardCost.map(function (item) { return ({
            amount: Long.fromValue(item.amount),
            typeId: item.resourceId,
        }); });
        var missingResources = selectNotEnoughResourcesMissingResources(state, standardCostItem);
        if (missingResources.length > 0) {
            return path;
        }
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/checks/checkBuildingUpgradeHasEnoughResourceStandard.ts
// module id = 2074
// module chunks = 3